import { EnvironmentVariables } from "@/modules/common/types";
import { Button, Typography, Box } from "@mui/material";
import { ChevronRightIcon } from "lucide-react";

interface ViewListingProps {
  compoundId: string | number;
  inventoryListingId: number | undefined;
}

export default function ViewListing({
  compoundId,
  inventoryListingId,
}: ViewListingProps) {
  if (!inventoryListingId) return;
  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Button
        sx={(t) => ({
          display: "flex",
          gap: t.nawy.spacing.xs,
          color: t.nawy.colors.semantic.text.accent,
          textTransform: "none",
          ...t.nawy.typography.english.variants.body.md.semibold,
        })}
        variant="text"
        href={`${EnvironmentVariables.LISTING_URL}/compound/${compoundId}/property/${inventoryListingId}`}
        target="_blank"
      >
        View Listing <ChevronRightIcon size={16} />
      </Button>
      <Typography
        sx={(t) => ({
          ...t.nawy.typography.english.variants.body.sm.regular,
          color: t.nawy.colors.semantic.text.secondary,
        })}
      >
        Listing ID #{inventoryListingId}
      </Typography>
    </Box>
  );
}
